import React from 'react';
import { useSelector } from 'react-redux'
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import Dashboard from './Dashboard/Dashboard';
import Map from './Map/Map';
import Collectors from './Collectors/Collectors';
import Printers from './Printers/Printers';
import Hosts from './Hosts/Hosts';
import Efts from './Efts/Efts';
import { SioConnector } from '../../components';

import './Devices.css';

const Devices = ({ match }) => {
    const { user } = useSelector(state => state.auth);

    const { api_key, engine_url } = user.tkt_instance;
    return (
        <div className="Devices">
            <SioConnector apiKey={api_key} serverUrl={engine_url}>
                <ContainerWrapper container="settings">
                    <Route path="/devices/hosts"><Hosts /></Route>
                    <Route path="/devices/collectors"><Collectors /></Route>
                    <Route path="/devices/printers"><Printers /></Route>
                    <Route path="/devices/efts"><Efts /></Route>
                    <Route path="/devices/list"><Dashboard /></Route>
                    <Route exact path={ `${ match.url }/` } component={Map} />
                </ContainerWrapper>
            </SioConnector>
        </div>
    );
}

export default Devices;
